import React from "react";
import Page from "../Page";

const DI = ({ testResult }) => {
  return (
    <>
      <Page testResult={testResult} title="معرفی الگوی رفتاری DI">
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری DI، ترکیبی از دو ویژگی برجسته "تسلط‌گرایی" D و
          "تأثیرگذاری" I هستند، با این تفاوت که شاخص D در آن‌ها غالب است و I در
          لایه دوم قرار دارد. این افراد بسیار پرانرژی، سریع‌العمل، تصمیم‌گیر،
          نتیجه‌گرا، خوش‌بیان و تأثیرگذار هستند.
        </p>

        <p className="text-gray-800 leading-7">
          آن‌ها معمولا در مواجهه با چالش‌ها پیش‌قدم می‌شوند، از رقابت لذت
          می‌برند، از ریسک نمی‌ترسند، و دوست دارند کنترل امور را به‌دست بگیرند.
          ترکیب نفوذ اجتماعی بالا با اراده‌ی قوی، از آن‌ها افرادی تبدیل کرده که
          می‌توانند تیمی را هدایت، انگیزه‌بخشی کنند و هم‌زمان نتیجه را هم مطالبه
          کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          فردی با الگوی DI ممکن است در یک جلسه فروش، نه‌تنها سریع به اصل موضوع
          برود و پیشنهاد خود را قاطعانه مطرح کند، بلکه با زبان بدن، شور و هیجان
          و انرژی بالا دیگران را نیز جذب و متقاعد کند. اما ممکن است در مواجهه با
          تأخیر همکار یا عدم اجرای دقیق جزئیات، صبرش لبریز شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری الگوی DI"
      >
        <div className="text-gray-800 space-y-4">
          <p className="text-gray-800 leading-7">
            الگوی DI ترکیبی از دو بُعد رفتاری اصلی در مدل DISC است:
          </p>

          <div>
            <h4 className="font-semibold mb-2">
              1. تسلط D - Dominance - بُعد غالب
            </h4>

            <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
              <li>تمرکز بالا روی نتیجه‌گیری، اقدام سریع و غلبه بر موانع</li>
              <li>
                تمایل به گرفتن کنترل امور، تصمیم‌گیری قاطع و ورود به چالش‌ها
              </li>
              <li>بی‌تابی در برابر تعلل، جزئیات بیش از حد، یا افراد کند</li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-2">
              2. تأثیرگذاری I - Influence - بُعد پشتیبان
            </h4>

            <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
              <li>
                توانایی بالا در متقاعدسازی، ایجاد ارتباط با دیگران و جلب اعتماد
              </li>
              <li>
                استفاده از شور و هیجان، زبان بدن و نفوذ کلامی برای تأثیرگذاری
              </li>
              <li>
                علاقه به تعاملات انسانی، دیده‌شدن، و به‌دست‌آوردن تأیید اجتماعی
              </li>
            </ul>
          </div>
        </div>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های شاخص افراد با الگوی">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توضیح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  ویژگی
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  آن‌ها هم از لحاظ فکری و هم رفتاری سریع هستند و تمایل دارند
                  محیط اطراف را به تحرک وادار کنند.
                </td>
                <td className="border border-gray-300 p-3">
                  انرژی و تحرک بالا
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  ترکیبی از خوش‌مشربی با تمایل به رهبری و فرماندهی
                </td>
                <td className="border border-gray-300 p-3">
                  برون‌گرایی توأم با کنترل‌گرایی
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  معمولاً بدون ترس از اشتباه، تصمیم‌گیری می‌کنند و عاشق چالش
                  هستند.
                </td>
                <td className="border border-gray-300 p-3">ریسک‌پذیری بالا</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  این افراد همیشه دنبال صعود به سطح بعدی، فرصت‌های بزرگ‌تر و
                  موفقیت چشمگیرتر هستند.
                </td>
                <td className="border border-gray-300 p-3">
                  جاه‌طلبی و بلندپروازی
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  آن‌ها دوست دارند دیگران توانمندی‌هایشان را ببینند و تایید
                  کنند.
                </td>
                <td className="border border-gray-300 p-3">
                  نیاز به تحسین و تأیید اجتماعی
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="نقاط قوت اصلی">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>جسارت</li>
          <li>قدرت رهبری و مدیریت بحران در تصمیم‌گیری</li>
          <li>مهارت متقاعدسازی</li>
          <li>انگیزه‌دهی به اطرافیان</li>
          <li>ابتکار عمل و سرعت در اجرا</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="چالش‌های احتمالی">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>صبر پایین در برابر کندی یا عدم پیروی</li>
          <li>توجه ناکافی به جزئیات و کیفیت</li>
          <li>تمایل به تک‌روی یا دستوردهی بدون شنیدن نظرات دیگران</li>
          <li>ناپایداری در پیگیری‌های بلندمدت</li>
          <li>گاه تأثیرپذیری از احساس لحظه‌ای در تصمیم‌گیری</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="اگر در یک تیم کاری باشند">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>به‌عنوان لیدر عمل می‌کنند، حتی اگر نقش رسمی نداشته باشند.</li>
          <li>دوست دارند در تصمیم‌گیری‌های کلیدی نقشی فعال داشته باشند.</li>
          <li>
            سریع وارد عمل می‌شوند و از دیگران نیز همین سرعت را انتظار دارند.
          </li>
          <li>
            در مواجهه با مخالفت ابتدا فشار وارد می‌کنند، سپس تلاش به اقناع
            می‌کنند.
          </li>
          <li>می‌توانند تیم را هدایت و انگیزه‌بخش اعضا باشند.</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="تشریح الگوی رفتاری DI">
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری DI مثل موتورهای پرشتاب هستند که هم قدرت رانندگی
          دارند و هم صدای بوقشان بلند است! آن‌ها با ترکیبی از اراده و هیجان،
          محیط اطرافشان را به حرکت وامی‌دارند. برخلاف High DI که اغلب تعادلی بین
          D و I دارد، در DI شاخص تسلط D غالب است و ویژگی‌های I در خدمت این تسلط
          قرار می‌گیرد. <br /> <br /> این یعنی: آن‌ها اول تصمیم می‌گیرند، بعد
          تأثیر می‌گذارند! باور دارند که اگر راهی وجود ندارد، باید یکی ساخت. بعد
          از انتخاب مسیر، با شور و هیجان دیگران را با خود همراه می‌کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="سبک ارتباطی افراد DI">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>سریع، صریح، گاهی صدامحور و دستوری</li>
          <li>استفاده از زبان بدن قوی و نفوذ کلام</li>
          <li>شوخ‌طبع ولی در عین حال جدی در هدف</li>
          <li>
            در برخورد با مخالفت ابتدا سعی در اقناع دارند؛ در صورت عدم موفقیت،
            فشار مستقیم وارد می‌کنند
          </li>
          <li>در شبکه‌سازی و متقاعدسازی مهارت ذاتی دارند</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="رفتار DI در شرایط معمول">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>پرانرژی، انگیزه‌دهنده و محرک دیگران</li>
          <li>عاشق مسئولیت و نقش‌های کلیدی</li>
          <li>تمایل بالا به نتیجه، حتی به قیمت عبور از برخی فرآیندها</li>
          <li>خسته از جلسات طولانی، بوروکراسی و انتظار کشیدن</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="رفتار DI تحت فشار">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>ممکن است صراحت تبدیل به تحکم شود</li>
          <li>گاهی تصمیمات عجولانه با نگرش کوتاه‌مدت اتخاذ می‌کنند</li>
          <li>ممکن است اصرار زیادی برای قانع‌کردن دیگران داشته باشند</li>
          <li>واکنش‌هایی با هیجان بالا و کنترل پایین به اتفاقات ناگهانی</li>
          <li>احتمال عبور از مرزهای دیگران برای رسیدن به هدف وجود دارد</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="اگر DI در یک پروژه تیمی باشد">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>
            معمولاً نقش لیدر غیررسمی را ایفا می‌کند، حتی اگر سمتی نداشته باشد.
          </li>
          <li>
            اگر ببیند افراد کند یا بی‌انگیزه هستند، وارد عمل می‌شود و هدایت را
            به‌دست می‌گیرد.
          </li>
          <li>
            ممکن است با افراد منطقی و جزئی‌نگر مثل C یا CS دچار تعارض شود، چون
            می‌خواهد سریع به هدف برسد.
          </li>
          <li>
            با افراد High I یا IS راحت‌تر کار می‌کند چون هیجان و حمایت متقابل
            دارند.
          </li>
        </ul>
      </Page>

      <Page testResult={testResult} title="مثال واقعی">
        <p className="text-gray-800 leading-7">
          یک مدیر فروش DI در شرایط رکود بازار، به‌جای نشستن و تحلیل آمار،
          بلافاصله طرح فروش فوری طراحی می‌کند، به تیم انگیزه می‌دهد، خودش زنگ
          می‌زند، مشتری‌ها را پیگیری می‌کند، و تیم را با هیجان بالا به جلو هل
          می‌دهد. اما ممکن است فراموش کند که محصول هنوز آماده تحویل نیست یا
          فرآیند مالی هماهنگ نشده!
        </p>
      </Page>

      <Page testResult={testResult} title="فیلم پیشنهادی">
        <p className="text-gray-800 leading-7">
          The Wolf of Wall Street شخصیت جردن بلفورت با بازی لئوناردو دی‌کاپریو
          نمونه‌ای اغراق‌شده از یک DI است: با ترکیب قدرت، شور، هیجان، نفوذ کلام
          و ریسک‌پذیری.
        </p>
      </Page>

      <Page testResult={testResult} title="انگیزه شما در تیپ DI">
        <div className="text-gray-800 leading-7 space-y-3">
          <p>
            افراد دارای الگوی رفتاری DI با ترکیب دو نیروی محرکه‌ی اصلی حرکت
            می‌کنند:
          </p>

          <ul className="list-disc list-inside space-y-1">
            <li>نیاز به برتری و نتیجه‌گیری (D)</li>
            <li>تمایل به دیده‌شدن و اثرگذاری اجتماعی (I)</li>
          </ul>

          <p>
            این دو انگیزه DI را به یک موتور هیجانیِ هدف‌محور تبدیل می‌کنند که،
            در صورت فراهم بودن فضای مناسب، می‌تواند تیم، پروژه یا حتی یک سازمان
            را به جلو هل دهد.
          </p>
        </div>
      </Page>

      <Page testResult={testResult} title="مهم‌ترین عوامل انگیزشی DI">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توضیح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  عامل
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  DIها وقتی پیشرفتشان دیده شود و مورد تحسین قرار بگیرند،
                  انگیزه‌شان چند برابر می‌شود.
                </td>
                <td className="border border-gray-300 p-3">
                  موفقیت قابل مشاهده
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  برایشان مهم است که خودشان مسیر را انتخاب کنند، نه اینکه کسی
                  بالا سرشان باشد.
                </td>
                <td className="border border-gray-300 p-3">
                  آزادی در عمل و تصمیم‌گیری
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  پروژه‌های روتین و تکراری، برایشان خسته‌کننده است؛ باید حس
                  رقابت، چالش یا بحران وجود داشته باشد.
                </td>
                <td className="border border-gray-300 p-3">
                  چالش‌های هیجان‌انگیز
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  چه در نقش یک لیدر، چه فروشنده، چه سخنران،اثرگذاری در ذات DI
                  است.
                </td>
                <td className="border border-gray-300 p-3">
                  فرصت برای اثرگذاری بر دیگران
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  فضای کند و اداری، انرژی آن‌ها را می‌کشد. آن‌ها عاشق محیط‌های
                  سریع، پویا و تصمیم‌محورند.
                </td>
                <td className="border border-gray-300 p-3">سرعت و تحرک بالا</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title=" واکنش انگیزشی DI به شرایط متفاوت">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>
            اگر کسی یا چیزی رشد آن‌ها را محدود کند: عصبی، بی‌قرار و گاهی پرخاشگر
            می‌شوند.
          </li>
          <li>
            اگر فرصت دیده‌شدن، رقابت یا رشد وجود داشته باشد: با تمام توان وارد
            می‌شوند.
          </li>
          <li>
            اگر در تیمی کند یا بی‌انگیزه قرار بگیرند: احتمالاً رهبری را به‌دست
            می‌گیرند یا تیم را ترک می‌کنند.
          </li>
        </ul>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          فرض کنید یک کارمند DI در تیمی حضور دارد که جلسات طولانی و بی‌نتیجه
          برگزار می‌شود. بعد از دو جلسه، او داوطلب می‌شود تا ساختار جلسه را عوض
          کند، تصمیمات را لیست کند، ضرب‌العجل تعریف کند و پیگیری را خودش انجام
          دهد ، چون به نتیجه نرسیدن برایش عذاب‌آور است. اما اگر دیده نشود؟ ممکن
          است تیم را ترک کند و به محیطی پویا‌تر بپیوندد.
        </p>
      </Page>

      <Page testResult={testResult} title="نکته کلیدی">
        <p className="text-gray-800 leading-7">
          «اگر DI حس کند کارش دیده نمی‌شود یا دیگران آن را جدی نمی‌گیرند، به
          سرعت انگیزه‌اش را از دست می‌دهد.»
        </p>
      </Page>

      <Page
        testResult={testResult}
        title=" عادت‌های کاری افراد با الگوی رفتاری DI"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی DI، معمولاً در محیط کاری پرشور، پرتحرک و با ریتم بالا
          شکوفا می‌شوند. آن‌ها عاشق پیشرفت هستند، و ترجیح می‌دهند در مرکز
          اتفاقات مهم و تأثیرگذار قرار بگیرند. ترکیب قاطعیت D و تعامل اجتماعی I
          آن‌ها را به افرادی تبدیل می‌کند که هم می‌توانند تصمیم بگیرند و اجرا
          کنند، هم دیگران را با خود همراه سازند.
        </p>
      </Page>

      <Page testResult={testResult} title="عادت‌های شاخص کاری DI">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توضیح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  رفتار کاری
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  آن‌ها اهل منتظر ماندن نیستند. اگر ساختار مشخص نباشد، خودشان آن
                  را تعریف می‌کنند.
                </td>
                <td className="border border-gray-300 p-3">
                  ابتکار و رهبری در شرایط مبهم
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  فرآیند برایشان مهم نیست، هدف مهم است! هر چیزی که مانع نتیجه
                  باشد، کنار می‌گذارند.
                </td>
                <td className="border border-gray-300 p-3">
                  تمرکز روی هدف نهایی
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  تمایل دارند همه‌چیز سریع پیش برود؛ گاهی همین سرعت، دقت یا عمق
                  را قربانی می‌کند.
                </td>
                <td className="border border-gray-300 p-3">
                  سریع ولی گاهی شتاب‌زده
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  وقتی مسئولیت داشته باشند، به آن افتخار می‌کنند و می‌خواهند در
                  آن بدرخشند.
                </td>
                <td className="border border-gray-300 p-3">
                  تمایل به مسئولیت و قدرت
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  شوخ‌طبع، معاشرتی، پرحرارت و الهام‌بخش؛ اما ممکن است حوصله
                  انتقاد مستقیم یا مخالفت را نداشته باشند.
                </td>
                <td className="border border-gray-300 p-3">
                  روابط کاری پرانرژی و کاریزماتیک
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title=" رفتارهای بالقوه منفی در محیط کار">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>بی‌حوصلگی نسبت به کارهای روتین یا جزئی‌نگرانه</li>
          <li>انجام چند کار به‌صورت موازی ولی نیمه‌تمام</li>
          <li>نارضایتی از مدیریت خرد یا کنترل شدید بالا‌دستی</li>
          <li>بی‌توجهی به جزئیات در اجرا یا گزارش‌دهی</li>
          <li>عدم تمایل به مستندسازی یا پیروی از فرآیند رسمی</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="پیشنهاد رفتاری">
        <div className="text-gray-800 leading-7 space-y-3">
          <p>برای افزایش کارایی، DIها می‌توانند از اقدامات زیر بهره ببرند:</p>

          <ul className="list-disc list-inside space-y-1">
            <li>
              یک دستیار دقیق و جزئی‌نگر در کنار خود داشته باشند (مثل یک C یا CS)
            </li>
            <li>برای کارهای بزرگ‌تر، نقشه اجرایی و فازبندی تنظیم کنند</li>
            <li>قبل از تصمیم نهایی، لحظه‌ای تأمل و بررسی ریسک را تمرین کنند</li>
            <li>
              در بازخورد دادن یا اعمال نظر، حوصله و احترام بیشتری لحاظ کنند
            </li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          فردی با الگوی DI که مسئول بازاریابی است، به‌جای اجرای کمپین بر اساس
          مراحل تاییدشده، مستقیم طرح را به اجرا می‌گذارد تا «فرصت از دست نرود».
          در کوتاه‌مدت مؤثر است، اما ممکن است مشکلاتی از نظر هماهنگی یا بودجه
          ایجاد کند.
        </p>
      </Page>

      <Page testResult={testResult} title="دیدگاه‌های افراد در تیپ DI">
        <p className="text-gray-800 leading-7">
          الگوی DI جهان را مثل یک رقابت بزرگ می‌بیند، اما رقابتی همراه با هیجان
          و فرصت‌های اثرگذاری. این افراد به ‌دنبال برد سریع و دیده شدن هستند.
          آن‌ها با اعتماد به نفس وارد هر جمعی می‌شوند و تمایل دارند در مرکز توجه
          یا تصمیم‌گیری قرار بگیرند.
        </p>
      </Page>

      <Page testResult={testResult} title="دیدگاه DI درباره خود">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>«من توانمند، قوی و تأثیرگذارم.»</li>
          <li>
            «می‌توانم از پس هر کاری بربیایم؛ فقط کافی است دست به کار شوم.»
          </li>
          <li>«اگر دیده نشوم، بی‌فایده‌ست که برنده باشم.»</li>
          <li>«دیگران باید همراهم شوند؛ من مسیر را می‌شناسم.»</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="دیدگاه DI درباره دیگران">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>دیگران را به چشم همکاران مفید یا موانع احتمالی می‌بینند.</li>
          <li>
            اگر فردی کند، مردد یا بیش‌ازحد محتاط باشد، ممکن است DI آن را تحمل
            نکند یا از او عبور کند.
          </li>
          <li>
            افرادی که پرانرژی، فعال، خوش‌صحبت و قابل‌اعتمادند، در چشم DIها
            جذاب‌اند.
          </li>
          <li>
            DI برای ارتباط به هیجان و سرعت پاسخ حساس است؛ افراد خاموش یا خنثی او
            را کلافه می‌کنند.
          </li>
        </ul>
      </Page>

      <Page testResult={testResult} title="دیدگاه DI نسبت به محیط">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>محیط باید فرصت‌محور، پرتحرک و الهام‌بخش باشد.</li>
          <li>
            محیط‌هایی با ساختار خشک، سلسله‌مراتب زیاد یا رویه‌های سنگین، DI را
            بی‌انگیزه می‌کند.
          </li>
          <li>
            آن‌ها به فضای باز، آزادی در تصمیم‌گیری و گاهی آزادی در لباس پوشیدن
            علاقه دارند.
          </li>
        </ul>
      </Page>

      <Page testResult={testResult} title="چالش‌های دیدگاهی DI">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  راهکار پیشنهادی
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  چالش
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  تمرین شنیدن فعال، حتی اگر تصمیم نهایی را خودتان می‌گیرید
                </td>
                <td className="border border-gray-300 p-3">
                  نادیده گرفتن دیدگاه دیگران
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  مکث قبل از قضاوت؛ شناخت عمیق‌تری از توانایی‌های اطرافیان داشته
                  باشید
                </td>
                <td className="border border-gray-300 p-3">
                  ارزیابی سطحی افراد
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  یادآوری این جمله: «سریع رفتن خوب است، ولی اگر در مسیر اشتباه
                  باشی، فاجعه است.»
                </td>
                <td className="border border-gray-300 p-3">
                  اصرار بر سرعت به جای کیفیت
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          در یک جلسه تیمی، DI با انرژی بالا ایده‌ای را مطرح می‌کند. یکی از
          همکاران مثلاً فردی با الگوی C با دقت از زوایای منطقی ایراداتی مطرح
          می‌کند. DI در ابتدا ممکن است این کار را نوعی مخالفت تلقی کند و واکنش
          نشان دهد. اما اگر آموزش‌دیده باشد، درک می‌کند که این دیدگاه‌ها مکمل
          حرکت سریع او هستند، نه مانع.
        </p>
      </Page>

      <Page testResult={testResult} title="اوقات فراغت در تیپ DI">
        <p className="text-gray-800 leading-7">
          افراد با الگوی DI در اوقات فراغت هم بیکار نمی‌نشینند! آن‌ها حتی وقتی
          استراحت می‌کنند، به‌نوعی در حال رقابت، یادگیری، تأثیرگذاری یا خلق
          هستند. تفریح برای DI فقط آرامش نیست، بلکه اغلب ترکیبی از هیجان، کشف،
          تعامل و حتی رقابت دوستانه است.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌های برجسته در انتخاب تفریح و فراغت"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توضیح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  ویژگی
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  کمتر پیش می‌آید DI تمام یک روز را به لم‌دادن بگذراند؛ باید
                  حرکتی در کار باشد.
                </td>
                <td className="border border-gray-300 p-3">پر انرژی و فعال</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  علاقه‌مند به حضور در جمع، شرکت در چالش‌ها، و تفریحاتی با بار
                  هیجانی بالا.
                </td>
                <td className="border border-gray-300 p-3">
                  اجتماعی و گروه‌محور
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  بازی‌های تیمی، چالش‌های فکری، ورزش‌هایی مثل تنیس، بدمینتون، یا
                  دوچرخه‌سواری با دوستان.
                </td>
                <td className="border border-gray-300 p-3">
                  رقابتی حتی در تفریح
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  هر چیزی که «جدید» باشد برای DI جذاب است: سفر به جایی خاص،
                  امتحان یک غذای متفاوت، ثبت‌نام در کارگاه جدید.
                </td>
                <td className="border border-gray-300 p-3">
                  اهل تجربه و تنوع‌طلب
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="رفتارهای معمول DI در اوقات فراغت">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>برنامه‌ریزی می‌کند اما اغلب در لحظه تصمیم می‌گیرد</li>
          <li>اگر با خانواده باشد، معمولاً لیدر تفریح است</li>
          <li>
            اگر تنها باشد، خود را با پروژه‌های شخصی یا علاقه‌مندی‌ها سرگرم
            می‌کند
          </li>
          <li>
            ممکن است تفریح را با توسعه شخصی ترکیب کند (مثلاً شنیدن پادکست هنگام
            پیاده‌روی یا ورزش)
          </li>
        </ul>
      </Page>

      <Page testResult={testResult} title="توصیه‌ مهم">
        <p className="text-gray-800 leading-7">
          اوقات فراغت برای DI باید فرصتی برای تخلیه هیجان و دستیابی به انرژی
          دوباره باشد، نه فقط آرامش یا فرار از کار. همچنین بهتر است یاد بگیرند
          که گاهی لازم است فقط استراحت کرد، نه رقابت!
        </p>
      </Page>

      <Page testResult={testResult} title="مثال واقعی">
        <p className="text-gray-800 leading-7">
          فردی با تیپ DI برای آخر هفته تصمیم می‌گیرد با دوستانش به کوهنوردی
          برود. در مسیر بالا، مسابقه می‌گذارد که چه کسی زودتر به قله می‌رسد! در
          کمپ، شروع می‌کند به تعریف استراتژی بازاریابی جدیدی که در ذهنش جرقه زده
          است، و شب همان ایده را برای دوستانش پرزنت می‌کند.
        </p>
      </Page>

      <Page testResult={testResult} title="فیلم پیشنهادی برای سبک فراغت DI">
        <p className="text-gray-800 leading-7">
          Yes Man 2008 با بازی جیم کری شخصیتی که تصمیم می‌گیرد به همه پیشنهادات
          "بله" بگوید و وارد موقعیت‌های پرریسک، متفاوت و اجتماعی شود. DIها با
          چنین موقعیت‌هایی راحت‌تر کنار می‌آیند و حتی لذت می‌برند.
        </p>
      </Page>

      <Page testResult={testResult} title="تصمیم‌گیری در تیپ DI">
        <p className="text-gray-800 leading-7">
          تصمیم‌گیری برای افراد DI مانند جهش به‌سمت یک فرصت تازه است. آن‌ها در
          تصمیم‌گیری، سریع، قاطع و پرانرژی‌اند اما گاهی جزئیات و پیامدهای
          بلندمدت را نادیده می‌گیرند. ترکیب ویژگی ریسک‌پذیر D با هیجان‌طلبی I
          باعث می‌شود DIها تصمیمات جسورانه‌ بگیرند، اما برخی مواقع از روی
          شتاب‌زدگی یا هیجان لحظه.
        </p>
      </Page>

      <Page testResult={testResult} title="سبک تصمیم‌گیری DI چگونه است؟">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توضیح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  ویژگی
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  زیاد وارد فاز تحلیل نمی‌شوند، ترجیح می‌دهند "انجامش بدهند، بعد
                  اصلاحش کنند".
                </td>
                <td className="border border-gray-300 p-3">
                  سرعت بالا در تصمیم‌گیری
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  وقتی هیجان‌زده‌اند یا موقعیت را فرصت تلقی می‌کنند، زود تصمیم
                  می‌گیرند.
                </td>
                <td className="border border-gray-300 p-3">
                  وابسته به احساسات لحظه‌ای
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  حتی اگر اطلاعات کافی نداشته باشند، خودشان را قانع می‌کنند که
                  "درستش می‌کنند".
                </td>
                <td className="border border-gray-300 p-3">
                  اعتماد بالا به خود و ایده‌ها
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  اگر متوجه اشتباه شوند، می‌توانند مسیر را سریع تغییر دهند
                  برخلاف الگوهای C یا S .
                </td>
                <td className="border border-gray-300 p-3">
                  انعطاف‌پذیری بالا بعد از تصمیم
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="خطرات احتمالی در تصمیم‌گیری DI">
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>نادیده گرفتن جزئیات و محدودیت‌ها</li>
          <li>کم‌توجهی به پیامدهای قانونی یا اخلاقی</li>
          <li>بی‌توجهی به نظرات مخالف</li>
          <li>انتخاب‌های احساسی به‌جای منطقی</li>
          <li>شروع چند پروژه هم‌زمان بدون برنامه دقیق</li>
        </ul>
      </Page>

      <Page
        testResult={testResult}
        title="توصیه‌های کاربردی برای بهبود تصمیم‌گیری"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  چرا مؤثر است؟
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  توصیه
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  گاهی یک شب خوابیدن روی تصمیم، مسیر را تغییر می‌دهد.
                </td>
                <td className="border border-gray-300 p-3">
                  مکث قبل از تصمیم نهایی
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  آن‌ها جنبه‌های پنهان و منطقی را بررسی می‌کنند.
                </td>
                <td className="border border-gray-300 p-3">
                  مشورت با تیپ‌های C یا CS
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  جدول سود-زیان ساده‌ای طراحی کنند حتی ذهنی.
                </td>
                <td className="border border-gray-300 p-3">
                  ارزیابی پیامدهای احتمالی
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  این حالت‌ها سرعت را افزایش می‌دهند، ولی دقت را می‌کُشند.
                </td>
                <td className="border border-gray-300 p-3">
                  پرهیز از تصمیم در اوج هیجان یا عصبانیت
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title=" مثال کاربردی">
        <p className="text-gray-800 leading-7">
          فرد DI که برای راه‌اندازی یک استارتاپ هیجان‌زده شده، بدون بررسی بازار،
          فقط با چند ایده و انرژی بالا، دفتر می‌گیرد و کار را شروع می‌کند. چند
          ماه بعد متوجه می‌شود محصول نیاز بازار نبوده. اگر قبل از شروع، نیم‌ساعت
          وقت می‌گذاشت تا با چند مشتری بالقوه صحبت کند، مسیرش اصلاح می‌شد.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاداتی برای بهبود فرآیند تصمیم‌گیری"
      >
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی: The Social Network شخصیت مارک زاکربرگِ فیلم، از
          تصمیم‌گیرندگان سریع و اثرگذار است، اما تضادش با افراد منطقی و محتاط‌تر
          مثل شریکش، نمونه‌ای از چالش تصمیم‌گیری‌های تیپ DI است.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهادات جهت بهبود عملکرد DI">
        <div className="text-gray-800 space-y-3">
          <p className="leading-7">
            افراد با تیپ رفتاری DI ترکیبی نیرومند از قاطعیت، اشتیاق، انرژی و
            نفوذ اجتماعی دارند. آن‌ها پیشرو، الهام‌بخش و آغازگرند؛ اما تعدادی از
            رفتارها را با تمرین می‌توان تقویت یا تعدیل کرد تا عملکرد پایدارتر و
            اثربخش‌تری داشته باشند.
          </p>

          <ol className="list-decimal list-inside leading-7 space-y-2">
            <li>
              مکث کن، بعد شروع کن — قبل از اقدام سریع، لحظه‌ای برای ارزیابی و
              مشورت با افراد دقیق‌تر وقت بگذارید.
            </li>
            <li>
              از هیجان تا عمق برو — جذابیت اولیه کافی نیست؛ عواقب، بودجه و
              برنامه‌ریزی بلندمدت را در نظر بگیرید.
            </li>
            <li>
              به دیگران فرصت اظهار نظر بده — گوش دادن فعال را تمرین کنید؛
              دیدگاه‌های دیگران مکمل تصمیم سریع شما هستند.
            </li>
            <li>
              مهارت‌های تکمیل‌کننده خود را بشناسید — با افراد C یا S تیمی تشکیل
              دهید تا پیگیری و دقت جایگزین کم‌توجهی شود.
            </li>
            <li>
              برنامه‌ریزی مکتوب داشته باش — اهداف، وظایف و نقاط بازبینی را
              بنویسید تا از پراکندگی یا فراموشی جلوگیری شود.
            </li>
            <li>
              تفاوت شور و شتاب را بشناس — اشتیاق را نگه دارید، اما دنبال استمرار
              و پیگیری باشید نه فقط شروع‌های پرهیجان.
            </li>
            <li>
              هیجان خود را مدیریت کن، نه سرکوب — در شرایط بحرانی احساسات را
              کنترل کنید و از تصمیم‌گیری در اوج هیجان پرهیز کنید.
            </li>
            <li>
              پذیرا باش، نه فقط پرزنت‌کننده — شنونده‌ای فعال باشید و بازخورد
              گرفتن را به‌عنوان فرصتی برای رشد ببینید.
            </li>
          </ol>
        </div>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          فرض کنید یک فرد DI در جایگاه مدیر بازاریابی شرکت قرار دارد. او به‌سرعت
          کمپین‌هایی را راه می‌اندازد، جلسات پرانرژی برگزار می‌کند و تیم را با
          هیجان پیش می‌برد. اما اگر گزارش‌ها را نخواند یا نظرات تیم مالی را
          نشنود، پروژه‌هایش پایدار نخواهند بود. اگر یاد بگیرد صبر، بررسی
          داده‌ها، و پرسش فعال را هم وارد سبک کاری‌اش کند، به یک مدیر بی‌رقیب
          تبدیل می‌شود.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهادات جهت بهبود عملکرد DI">
        <p className="text-gray-800 leading-7">
          فیلم پیشنهادی: Whiplash شلاق، فیلمی که درباره مرز باریک بین
          بلندپروازی، سخت‌کوشی و فشار بیش‌ازحد بر خود و دیگران است. DI ها
          می‌توانند از این فیلم درس‌های مهمی بگیرند.
        </p>
      </Page>

      <Page testResult={testResult} title="رمز موفقیت در تیپ DI">
        <p className="text-gray-800 leading-7">
          رمز موفقیت برای افراد DI در این است که یاد بگیرند چگونه انرژی، انگیزه
          و جذابیت خود را در مسیری متمرکز، مؤثر و پایدار هدایت کنند. این افراد
          ذاتاً برای شروع‌های بزرگ، ایجاد تغییر، تأثیرگذاری و رهبری ساخته
          شده‌اند، اما اگر تمرکز نکنند، شور آن‌ها به شلوغی، و سرعت‌شان به
          سطحی‌نگری تبدیل می‌شود.
        </p>
      </Page>

      <Page testResult={testResult} title="رمز موفقیت در تیپ DI">
        <div className="text-gray-800 space-y-3">
          <p className="leading-7">
            برای بهره‌مندی از نقاط قوت DI و دستیابی به موفقیت پایدار، نکات زیر
            را مدنظر قرار دهید:
          </p>

          <ol className="list-decimal list-inside leading-7 space-y-2">
            <li>
              تمرکز روی یک هدف بزرگ در یک بازه مشخص — به‌جای پراکندگی در ده‌ها
              کار، یک مأموریت را انتخاب کنید و تا پایان پیگیری کنید.
            </li>
            <li>
              تبدیل اشتیاق به استمرار — پایداری و پیگیری مهم‌تر از شروع
              هیجان‌انگیز است؛ برای تکمیل پروژه‌ها برنامه و تعهد داشته باشید.
            </li>
            <li>
              استفاده از تیم مکمل — برای پوشش نقاط ضعف، با افراد تیپ C، S و D
              همکاری کنید تا نظم، ثبات و برنامه‌ریزی تقویت شود.
            </li>
            <li>
              توسعه هوش هیجانی و خودآگاهی — کنترل احساسات و درک دیگران تأثیر شما
              را پایدارتر می‌کند.
            </li>
            <li>
              تبدیل نفوذ به نفوذ پایدار — نفوذ را با شفافیت و نتیجه‌سازی همراه
              کنید تا تأثیرتان ماندگار شود.
            </li>
            <li>
              ترکیب خلاقیت با تحلیل — ایده‌ها را با بررسی داده‌ها و ارزیابی‌ها
              همراه کنید تا نتایج عملی و هدفمند به‌دست آید.
            </li>
            <li>
              آرامش در برابر چالش‌ها — در موقعیت‌های پرفشار آرامش خود را حفظ
              کنید تا تصمیمات مؤثرتر و پایدارتری بگیرید.
            </li>
          </ol>

          <p className="text-gray-800 leading-7">
            جمع‌بندی رمز موفقیت DI: با قدرت شروع کن، با نظم ادامه بده، با تعهد
            تمامش کن.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت سایر لایه‌ها در تیپ DI"
      >
        <p className="text-gray-800 leading-7">
          الگوی DI ترکیبی از دو نیروی بزرگ است: قاطعیت D و نفوذ اجتماعی I . این
          تیپ‌ها می‌توانند پروژه‌ای را روشن کنند، جمعی را هدایت کنند و حرکتی را
          آغاز کنند. اما برای موفقیت پایدار، لازم است برخی جنبه‌ها را تقویت و
          برخی را تعدیل کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title=" تقویت لایه C و S برای تعادل بهتر در شخصیت DI"
      >
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  جمله یا توصیه‌ برای تکرار و نهادینه‌سازی
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  چرا مهم است؟
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  جنبه رفتاری
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  «جزئیات، ستون فقرات موفقیت هستند.»
                </td>
                <td className="border border-gray-300 p-3">
                  ایده‌ها خوب‌اند اما جزئیات‌اند که اجرا را می‌سازند
                </td>
                <td className="border border-gray-300 p-3">توجه به جزئیات C</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  «آرام‌تر برو تا درست‌تر ببینی.»
                </td>
                <td className="border border-gray-300 p-3">
                  عجله تصمیم را ضعیف می‌کند
                </td>
                <td className="border border-gray-300 p-3">
                  پرهیز از شتاب‌زدگی C
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  «پروژه‌ای که تمام نشود، انگار شروع نشده.»
                </td>
                <td className="border border-gray-300 p-3">
                  مسیر موفقیت، نظم می‌طلبد
                </td>
                <td className="border border-gray-300 p-3">
                  نظم و پیگیری فرآیندها C
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  «همراه کردن، از جلو زدن مهم‌تر است.»
                </td>
                <td className="border border-gray-300 p-3">
                  همه مثل تو سریع نیستند!
                </td>
                <td className="border border-gray-300 p-3">
                  صبوری در برخورد با دیگران S
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  «گاهی سکوت، بهترین اثرگذاری است.»
                </td>
                <td className="border border-gray-300 p-3">
                  تعامل دوطرفه، اعتبار می‌آورد
                </td>
                <td className="border border-gray-300 p-3">گوش دادن مؤثر S</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  «درک کن، پیش از آن‌که انتظار درک داشته باشی.»
                </td>
                <td className="border border-gray-300 p-3">
                  نفوذ عاطفی می‌سازد
                </td>
                <td className="border border-gray-300 p-3">
                  همدلی با احساسات دیگران S
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="تکنیک‌های کاربردی برای تقویت DI">
        <div className="text-gray-800 space-y-3">
          <p className="leading-7">
            برای افزایش کارایی و تداوم، تکنیک‌های زیر را تمرین کنید:
          </p>

          <ol className="list-decimal list-inside leading-7 space-y-2">
            <li>
              برای هر پروژه جدول زمان‌بندی و فازبندی مشخص تهیه کن.
              <ul className="list-disc list-inside space-y-1">
                <li>
                  از ابزارهایی مثل Trello یا Notion برای مدیریت استفاده کن.
                </li>
              </ul>
            </li>
            <li>
              با یک فرد تیپ C یا S همکار شو.
              <ul className="list-disc list-inside space-y-1">
                <li>همکاری با کسی دقیق‌تر و کندتر، مکمل توانایی‌های شماست.</li>
              </ul>
            </li>
            <li>
              عادت «مکث ۵ دقیقه‌ای» قبل از هر تصمیم ایجاد کن.
              <ul className="list-disc list-inside space-y-1">
                <li>
                  ۵ دقیقه صبر کن و از خود بپرس: «آیا چیزی هست که هنوز نمی‌دانم؟»
                </li>
              </ul>
            </li>
            <li>
              هر هفته یک «تحلیل آرام» بنویس.
              <ul className="list-disc list-inside space-y-1">
                <li>
                  به‌جای فقط عمل کردن، دست‌کم یک تحلیل کوتاه از عملکرد هفته
                  داشته باش.
                </li>
              </ul>
            </li>
            <li>
              سخنرانی‌ها و ارائه‌ها را با پرسش و مشارکت به پایان ببر.
              <ul className="list-disc list-inside space-y-1">
                <li>
                  اجازه بده دیگران نیز ایده بدهند تا پذیرش و پیگیری افزایش یابد.
                </li>
              </ul>
            </li>
          </ol>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="جملاتی برای تمرین ذهنی تقویت لایه S و C"
      >
        <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
          <li>همه لازم نیست مثل من سریع باشند.</li>
          <li>تأثیر عمیق‌تر از شنیدن آغاز می‌شود.</li>
          <li>هر ایده‌ای نیاز به ساختار دارد.</li>
          <li>جذابیت زمانی ماندگار است که همراه با برنامه باشد.</li>
          <li>تغییر زمانی مؤثر است که پایه‌ای محکم داشته باشد.</li>
        </ul>
      </Page>

      <Page testResult={testResult} title="دانش و مهارت‌های مورد نیاز الگوی DI">
        <p className="text-gray-800 leading-7">
          تیپ رفتاری DI با ویژگی‌هایی مانند رهبری، ابتکار و نفوذ اجتماعی شناخته
          می‌شود. برای تبدیل این توانایی‌ها به موفقیت پایدار، تمرکز بر مجموعه‌ای
          از مهارت‌های عملی، تحلیلی، ارتباطی و مدیریتی ضروری است.
        </p>
      </Page>

      <Page testResult={testResult} title="مدیریت هیجان و هوش هیجانی">
        <div className="text-gray-800 leading-7 space-y-2">
          <p>
            برای کنترل لحظات هیجانی و حفظ روابط تیمی، کار روی مهارت‌های زیر مفید
            است:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>آگاهی از هیجان‌های شخصی</li>
            <li>کنترل هیجان و پاسخ‌های رفتاری</li>
            <li>همدلی با دیگران</li>
            <li>مدیریت روابط اجتماعی</li>
          </ul>
          <p className="text-gray-800 leading-7">
            پیشنهاد آموزشی: دوره‌های Daniel Goleman در مورد EQ
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="برنامه‌ریزی استراتژیک و مدیریت پروژه"
      >
        <div className="text-gray-800 leading-7 space-y-2">
          <p>
            برای تبدیل ایده‌ها به نتایج‌ قابل‌تکرار، توانمندی‌های زیر را پرورش
            دهید:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>هدف‌گذاری دقیق (SMART Goals)</li>
            <li>تقسیم‌بندی مراحل اجرایی و فازبندی</li>
            <li>اولویت‌بندی وظایف و کنترل پیشرفت</li>
          </ul>
          <p className="text-gray-800 leading-7">
            منبع پیشنهادی: Getting Things Done از David Allen
          </p>
        </div>
      </Page>

      <Page testResult={testResult} title="تفکر تحلیلی و تصمیم‌گیری منطقی">
        <div className="text-gray-800 leading-7 space-y-2">
          <p>
            برای جلوگیری از تصمیم‌های عجولانه، مهارت‌های تحلیلی زیر ضروری‌اند:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>بررسی داده‌ها و تحلیل شواهد</li>
            <li>ارزیابی پیامدها و تحلیل هزینه–فایده</li>
            <li>ریسک‌سنجی و سنجش نتایج ممکن</li>
          </ul>
          <p className="text-gray-800 leading-7">
            پیشنهاد فیلم/مطالعه: The Imitation Game برای نگاه به تحلیل استراتژیک
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="مهارت‌های ارتباط مؤثر و ارائه حرفه‌ای"
      >
        <div className="text-gray-800 leading-7 space-y-2">
          <p>
            برای اثرگذاری کلامی در جلسات و ارائه‌ها، مهارت‌های زیر را تقویت
            کنید:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>فن بیان و کنترل زبان بدن</li>
            <li>طراحی اسلاید و پیام‌پردازی مؤثر</li>
            <li>استفاده از داستان‌گویی (storytelling) برای تأثیرگذاری</li>
          </ul>
          <p className="text-gray-800 leading-7">
            پیشنهاد: دوره‌های ارتباط و مذاکره حرفه‌ای
          </p>
        </div>
      </Page>

      <Page testResult={testResult} title="خودانضباطی و تمرکز بلندمدت">
        <div className="text-gray-800 leading-7 space-y-2">
          <p>
            برای پایداری در اجرای اهداف طولانی‌مدت، این مهارت‌ها کمک‌کننده‌اند:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>مدیریت زمان و برنامه‌ریزی روزانه</li>
            <li>ساخت عادت‌های موفقیت و پیگیری وظایف تا انتها</li>
            <li>ایجاد انگیزه پایدار</li>
          </ul>
          <p className="text-gray-800 leading-7">
            منبع پیشنهادی: Atomic Habits از James Clear
          </p>
        </div>
      </Page>

      <Page testResult={testResult} title="کار تیمی با تیپ‌های رفتاری متفاوت">
        <div className="text-gray-800 leading-7 space-y-2">
          <p>برای موفقیت در تیم‌های متنوع، روی این موارد تمرکز کنید:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>شناخت تیپ‌های DISC دیگران</li>
            <li>انعطاف در گفت‌وگو و تحمل تفاوت‌ها</li>
            <li>تشویق مشارکت اعضای کم‌حرف یا محافظه‌کار</li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="جمع‌بندی">
        <p className="text-gray-800 leading-7">
          «دی‌آی‌ها برای موفق شدن، باید شور خود را با شعور رفتاری ترکیب کنند.»
        </p>
      </Page>

      <Page testResult={testResult} title="مشاغل مناسب برای افراد با الگوی DI">
        <div className="text-gray-800 leading-7">
          <p>
            تیپ DI در مشاغلی که نیاز به تصمیم‌گیری مستقل، دیده‌شدن و تأثیرگذاری
            دارند، می‌درخشد. نمونه نقش‌ها:
          </p>

          <ol className="list-decimal list-inside space-y-2">
            <li>
              مدیر توسعه کسب‌وکار (Business Development Manager) — مناسب برای
              شبکه‌سازی و فرصت‌یابی.
            </li>
            <li>
              کارشناس ارشد فروش و بازاریابی — مسئول جذب مشتری و مذاکره در بازار
              رقابتی.
            </li>
            <li>
              مدیر روابط عمومی یا برند — ارتقای تصویر برند با خلاقیت و نفوذ
              شخصی.
            </li>
            <li>
              مربی توسعه فردی / سخنران انگیزشی — انتقال انگیزه و الهام‌بخشی به
              مخاطب.
            </li>
            <li>
              مشاور کسب‌وکار یا استارتاپ — طراحی مسیرهای نو و مدیریت ریسک.
            </li>
            <li>
              رهبر تیم‌های خلاق یا پروژه‌های تحول‌آفرین — هدایت تغییر و نوآوری.
            </li>
            <li>
              سرمایه‌گذار یا کارآفرین — فرصت‌سازی و مدیریت ریسک برای رشد
              کسب‌وکار.
            </li>
            <li>
              مدیر کمپین‌های تبلیغاتی و دیجیتال مارکتینگ — ترکیب خلاقیت و
              هدف‌گرایی.
            </li>
            <li>
              کارشناس استارتاپ‌ها و فضاهای نوآور — مناسب محیط‌های سرعتی و
              نامحدود.
            </li>
            <li>
              توسعه‌دهنده شبکه‌های حرفه‌ای — ساخت و گسترش شبکه‌های انسانی و
              حرفه‌ای.
            </li>
          </ol>
        </div>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های کلیدی الگوی DI">
        <div className="text-gray-800 leading-7 space-y-3">
          <p>
            افراد دارای الگوی رفتاری DI به‌صورت طبیعی دارای ویژگی‌های مثبت زیر
            هستند:
          </p>

          <ul className="list-disc list-inside space-y-1">
            <li>جذاب و کاریزماتیک</li>
            <li>سریع، اهل اقدام و پُرانرژی</li>
            <li>چالش‌پذیر، برون‌گرا و تأثیرگذار در روابط</li>
          </ul>

          <p>هم‌زمان ممکن است چالش‌هایی نیز بروز کند:</p>

          <ul className="list-disc list-inside space-y-1">
            <li>کم‌حوصلگی یا عجول بودن در مواجهه با جزئیات</li>
            <li>تمرکز زیاد بر نتیجه و گاهی کم‌توجهی به احساسات دیگران</li>
            <li>نیاز به رشد در مدیریت هیجان، خشم یا شنیدن نظرات مخالف</li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های مناسب همسر فرد DI">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  چرا مناسب است؟
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  ویژگی
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  برای آرام کردن هیجان‌ها و فضای پرتنش
                </td>
                <td className="border border-gray-300 p-3">صبور و شنونده</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  برای جلوگیری از تصمیم‌گیری‌های عجولانه
                </td>
                <td className="border border-gray-300 p-3">
                  منطقی و تحلیل‌گر C یا S
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  در کنار فرد پرانرژی و پُرحرف، تحمل بالایی می‌طلبد
                </td>
                <td className="border border-gray-300 p-3">انعطاف‌پذیر </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  چون DIها معمولاً فضای شخصی نیاز دارند، همسر چسبنده آن‌ها را
                  فراری می‌دهد
                </td>
                <td className="border border-gray-300 p-3">مستقل </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  برای وقتی که DI دچار خشم یا فشار کاری می‌شود
                </td>
                <td className="border border-gray-300 p-3">
                  همدل و کنترل‌کننده تنش
                </td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  تا بتواند در کنار فرد DI مسیر زندگی را همپای او طی کند
                </td>
                <td className="border border-gray-300 p-3">
                  اهل رشد شخصی و اجتماعی
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="نکاتی که همسر فرد DI باید بداند">
        <div className="text-gray-800 leading-7 space-y-3">
          <p>
            برای حفظ رابطه مؤثر با یک فرد DI، موارد زیر را در نظر داشته باشید:
          </p>

          <ol className="list-decimal list-inside space-y-2">
            <li>
              DI عاشق تحسین و تشویق است — از ایده‌ها و انرژی‌اش تقدیر کنید تا
              رابطه‌تان گرم بماند.
            </li>
            <li>
              از بحث مستقیم و تهدید پرهیز کنید — برخورد تهاجمی یا تهدیدآمیز
              معمولاً مقاومت یا پرخاشگری ایجاد می‌کند.
            </li>
            <li>
              هنر مدیریت پشت‌صحنه را بیاموزید — گاهی با مدیریت ملایم عاطفی
              می‌توان مسیر او را به سمت سازندگی هدایت کرد.
            </li>
            <li>
              خلاق و نوآور باشید — زندگی با DI نیازمند جریانی از تجربه‌های جدید
              و هیجان است.
            </li>
            <li>
              اجازه دهید بدرخشد — در جمع‌ها فضایی برای دیده شدن و تأثیرگذاری او
              فراهم کنید.
            </li>
            <li>
              سریع پاسخ دهید — کندی در تصمیم‌گیری یا پاسخ‌دهی می‌تواند ناامیدی
              ایجاد کند.
            </li>
          </ol>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="نکاتی که فرد باید در زندگی زناشویی رعایت کند"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <p>برای حفظ رضایت و پایداری رابطه، این رفتارها را تمرین کنید:</p>

          <ol className="list-decimal list-inside space-y-2">
            <li>
              بیشتر گوش بده، کمتر پاسخ بده — شنیدن فعال گاهی از حل مشکل مهم‌تر
              است.
            </li>
            <li>
              به احساسات همسرت توجه کن — ممکن است او به فضای آرام‌تر و ثبات نیاز
              داشته باشد.
            </li>
            <li>
              از موضع بالا صحبت نکن — اقتدار شما با احترام و توجه حفظ می‌شود، نه
              دستور دادن.
            </li>
            <li>
              زمان با کیفیت بساز — وقت‌هایی بدون هدف کاری برای باهم بودن اختصاص
              دهید.
            </li>
            <li>
              در لحظه زندگی کن — توجه روزمره و کوچک به رابطه اهمیت زیادی دارد.
            </li>
          </ol>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="ارتباط مؤثر والدین DI با فرزندان و بالعکس"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <p>
            والدین DI معمولاً پرانرژی، هدف‌گرا و تصمیم‌گیر هستند؛ این ویژگی‌ها
            در تعامل با فرزندانی آرام‌تر یا احساس‌محور ممکن است چالش‌زا باشد.
          </p>

          <p className="font-semibold">چالش‌های معمول:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>سرعت زیاد در تصمیم‌گیری برای فرزند</li>
            <li>گوش ندادن به احساسات فرزند</li>
            <li>فشار زیاد برای نتیجه یا برتری</li>
            <li>توقع‌های بالا بدون توجه به سن یا ظرفیت کودک</li>
          </ul>

          <p className="font-semibold">نکات عملی برای بهبود ارتباط:</p>
          <ol className="list-decimal list-inside space-y-2">
            <li>
              صبور بودن را تمرین کنید — فرزندتان نسخه‌ای کوچک از شما نیست؛ با
              سرعت او همراه شوید.
            </li>
            <li>
              تحسین برای تلاش را فراموش نکنید — تأیید تلاش‌های کودک به رشد
              اعتمادبه‌نفس کمک می‌کند.
            </li>
            <li>
              کمتر سخنرانی، بیشتر شنیدن — گوش‌دادن فعال به جای توضیح‌های طولانی
              مؤثرتر است.
            </li>
            <li>
              بازی را ابزار یادگیری بدان، نه میدان مسابقه — بازی را لذت‌بخش نگه
              دارید.
            </li>
            <li>
              اشتباه را بخشی از یادگیری بدان — همراه فرزند در مسیر یادگیری
              باشید، نه مقابل او.
            </li>
            <li>
              قوانین را با گفتگو وضع کنید — از استبداد دوری کنید و اجازه مشارکت
              بدهید.
            </li>
          </ol>
        </div>
      </Page>

      <Page testResult={testResult} title="فیلم پیشنهادی برای درک بهتر">
        <p className="text-gray-800 leading-7">
          "Fin DIng Nemo" در جستجوی نمو پدر نِمو مارلین شخصیتی کنترل‌گر و
          نتیجه‌گراست. در طول داستان یاد می‌گیرد که گاهی باید رها کند و به
          فرزندش اعتماد کند. یک نمونه فوق‌العاده از تحول والدگری DIگونه به
          والدگری همدل.
        </p>
      </Page>

      <Page testResult={testResult} title="مثال کاربردی">
        <p className="text-gray-800 leading-7">
          مثال ۱: پدر DI از فرزندش انتظار دارد که در مسابقه مدرسه حتماً اول شود
          و مدال بیاورد. وقتی فرزندش دوم می‌شود، پدر لبخند می‌زند اما خیلی سریع
          می‌پرسد: "چرا نتونستی نفر اول باشی؟" این نوع نگاه باعث کاهش
          اعتمادبه‌نفس فرزند می‌شود. ✅ جایگزین: "من دیدم چقدر خوب تلاش کردی.
          دوم شدن هم خیلی ارزشمنده. دفعه بعد هم با هم کار می‌کنیم که حتی بهتر
          بشی." مثال ۲: مادر DI فرزندش را برای کلاس زبان ثبت‌نام کرده و توقع
          دارد در سه ماه انگلیسی روان صحبت کند. وقتی کودک پیشرفت کندی دارد، مادر
          شروع می‌کند به مقایسه و فشار. ✅ راه‌حل: در کنار فرزند بنشین، با او
          تمرین کن، و به جای فشار، مسیر یادگیری را لذت‌بخش کن.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چگونه با والد DI ارتباط مؤثر برقرار کنیم؟"
      >
        <div className="text-gray-800 leading-7 space-y-3">
          <p>
            والدین DI معمولاً پُرانرژی، سریع و تصمیم‌گیر هستند؛ برای برقراری
            ارتباط مؤثر، فرزندان می‌توانند از تکنیک‌های زیر استفاده کنند:
          </p>

          <ol className="list-decimal list-inside space-y-2">
            <li>
              با اعتمادبه‌نفس صحبت کن — صدای واضح و حالت مشخص جدی گرفته می‌شود.
            </li>
            <li>
              مستقیم و سریع حرف بزن — از حاشیه‌پردازی و توضیحات طولانی پرهیز کن.
            </li>
            <li>
              زمان مناسب را انتخاب کن — وسط کار یا جلسه والدین زمان مناسبی نیست.
            </li>
            <li>
              نتیجه‌محور صحبت کن — حرفی بزن که هدف و خروجی مشخص داشته باشد
              (مثلاً درخواست هزینه برای دوره همراه با توضیح فواید).
            </li>
            <li>
              از دستور دادن پرهیز کن — از عبارات مودبانه مثل «میشه لطفاً...» یا
              «اگه فکر می‌کنی مناسبه...» استفاده کن.
            </li>
            <li>
              قدردانی را فراموش نکن — جملات ساده تشکر می‌تواند سختی و مقاومت را
              کاهش دهد.
            </li>
          </ol>
        </div>
      </Page>

      <Page testResult={testResult} title="مثال تعاملی">
        <p className="text-gray-800 leading-7">
          وضعیت: پدر DI از فرزند می‌خواهد در آزمون ریاضی نمره کامل بگیرد. فرزند
          به جای اینکه بگوید "نمی‌تونم"، می‌گوید: «بابا من سعی می‌کنم نمره خوبی
          بگیرم، ولی اگه یه روز باهام تمرین کنی، احتمال موفقیتم بیشتره.» نتیجه؟
          پدر به‌جای عصبانیت، تبدیل به پشتیبان می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی برای نوجوانان و والدین DI"
      >
        <p className="text-gray-800 leading-7">
          "October Sky" آسمان اکتبر داستان نوجوانی که در دهه ۵۰ آمریکا می‌خواهد
          مهندس موشکی شود ولی پدرش تیپ DI کلاسیک سخت‌گیر، قاطع و نتیجه‌محور است.
          فیلمی آموزنده برای نمایش تعامل پسر و پدر با اختلاف دیدگاه زیاد.
        </p>
      </Page>
    </>
  );
};

export default DI;
